import { useQualificationsList } from '~/domains/taxonomies/queries/QualificationsList'

export const QualificationChipValue = ({ id }: { id: string }) => {
  const { data } = useQualificationsList()
  const name = data?.find((q) => String(q.id) === id)?.name
  return name ?? null
}
